import { composeEntityDrawerApiActions } from '@bp/admins-shared/features/entity';

import type { CreditCard } from '../../models';

export const ACTIONS_SCOPE = '[Drawer][CreditCard]';

const scope = `[API]${ ACTIONS_SCOPE }`;

export const CREDIT_CARD_DRAWER_API_ACTIONS = composeEntityDrawerApiActions<CreditCard>(scope);
